module.exports = __webpack_public_path__ + "img/10.c2388ab0.jpg";